import {ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ViewEncapsulation, Input} from '@angular/core';
import {MatDialog, MatDialogRef, MatDialogConfig} from '@angular/material';
import {FamilleMemberComponent} from '../../reservation/cours/cours.component';
import {DatePipe} from '@angular/common';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material';
import {MembrePlanningEspace} from '../../model/membrePlanningEspace.model';
import {Router, ActivatedRoute} from '@angular/router';
import {ClientService} from '../../service/client.service';
import {Utilisateur} from '../../model/utilisateur.model';
import {Client} from '../../model/client.model';
import {Espace} from '../../model/espace.model';
import {PlanningEspace} from '../../model/planningEspace.model';
import {Planning} from '../../model/planning.model';
import {PlanningMultiple} from '../../model/planningMultiple.model';
import {EspaceService} from '../../service/espace.service';
import {PlanningService} from '../../service/planning.service';
import * as moment from 'moment';
import * as localization from 'moment/locale/fr';
import {DaterangepickerDirective} from 'ngx-datepicker-material';
import {Moment} from 'moment';
import {ConfigService} from '../../shared/config.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../administration/confirm-dialog/confirm-dialog.component';
moment.locale('fr', localization);


@Component({
  selector: 'app-espace',
  templateUrl: './espace.component.html',
  styleUrls: ['./espace.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EspaceComponent implements OnInit {
  @ViewChild(DaterangepickerDirective) daterangepicker: DaterangepickerDirective;
  @ViewChild('datePicker') dpElement: ElementRef;
  @ViewChild('pickerButton') pickerButton: ElementRef;
  locale = {
    applyLabel: 'Appliquer',
    customRangeLabel: ' - ',
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: moment.localeData().firstDayOfWeek(),
  };
  id: string;
  currentUser: Utilisateur;
  clients: Client[];
  isfamille = false;

  espaceselected: Espace;
  espaces: Espace[];
  planningEspaces: PlanningEspace[];
  blocHeure = new Array();
  listeBlocHeure = [
    [6, 10],
    [10, 14],
    [14, 18],
    [18, 21]
  ];

  heureSelect = 0;

  dateDuJour: Date = new Date();
  maxDate: Moment;
  minDate: Moment;
  maDate: Date;
  dateInput: any;
  // nbjourShow: number = 7 - this.dateDuJour.getDay();
  nbjourShow = 6;
  nbjourParcours: number = 0;

  disableNext = false;
  disableprev = true;
  datePipe: DatePipe;

  infoClicked = false;


  dialogRef: MatDialogRef<FamilleMemberPlanningComponent>;
  lastCloseResult: string;
  configDialog: MatDialogConfig = {
    disableClose: false,
    width: '90vw',
    maxWidth: '450px',
    // maxHeight: '',
    panelClass: 'app-dialog-overlay',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  };

  autoHide = 5000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;
  showHours = false;
  classBlock = 'block-0';

  myFilter = (d: Date): boolean => {
    // const day = d.getDay();

    const dayDeb = new Date();
    const dayFin = new Date();

    dayFin.setDate(dayFin.getDate() + this.nbjourShow);
    dayDeb.setDate(dayDeb.getDate() - 1);

    // console.log(dayDeb);

    // Prevent Saturday and Sunday from being selected.
    return d >= dayDeb && d <= dayFin;
  }


  constructor(public dialog: MatDialog,
              private router: Router,
              private route: ActivatedRoute,
              private espaceService: EspaceService,
              private planningService: PlanningService,
              public snackBar: MatSnackBar,
              private renderer: Renderer2,
              private cdr: ChangeDetectorRef,
              private configService: ConfigService,
			  private clientService: ClientService,
  ) {
    this.datePipe = new DatePipe('en-US');

  }

  ngOnInit() {
	  // console.log("console.log(currentUser)")
    this.currentUser = JSON.parse(sessionStorage.getItem('parklife'));
    this.maDate = new Date();
    this.dateInput = moment();
    this.minDate = moment();
    this.maxDate = moment().add(this.nbjourShow, 'days');
    // console.log(this.minDate, this.maxDate);

    // this.id = this.route.snapshot.params['id'];
    // this.espaceService.get(this.id).subscribe(espace =>{
    //  this.espace = espace;
    //  this.titre = this.espace.designation;
    // });


	// console.log(this.currentUser)

   this.clientService.getByPere(this.currentUser.idclient).subscribe(membres => {
      this.clients = membres;
	  // console.log(" get by pere resultat ")
	  // console.log(this.clients.length)

      if (this.clients.length === 1) {
        this.isfamille = false;
      } else {
        this.isfamille = true;

      }
    });

    this.espaceService.getAll().subscribe(res => {
      this.espaces = res;
      // console.log('res=', res);
      // console.log('isUser=', this.currentUser.idutilisateur);
    });

    this.planningService._planningDelete.subscribe(resp => {
      // console.log ();
      if (resp && this.espaceselected) {
        // console.log('delecte planning');
        this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
      }
    });


  }

  reserver(plan: PlanningEspace, index: number) {

    // this.dialogRef = this.dialog.open(FamilleMemberComponent, this.config);
    // this.dialogRef.componentInstance.idEspace = '1';

    // this.dialogRef.afterClosed().subscribe(result => {
    //  this.lastCloseResult = result;
    //  this.dialogRef = null;
    // });
    // console.log(typeof plan.reserve);

    const config = new MatSnackBarConfig();

    if (plan.idplanning == '0') {
      const planning = new Planning();
      planning.datedebut = plan.datedebut;
      planning.datefin = plan.datefin;
      planning.idcours = 0;
      planning.idutilisateur = Number(this.currentUser.idutilisateur);
      planning.espace = this.espaceselected;

      // console.log('planning >', planning);

      this.planningService.create(planning).subscribe(res => {

        // console.log('res >', res);
        // console.log(res.idplanning);

        if (res.idplanning != '0') {
          const arrayIndex = this.planningEspaces.findIndex(_planning => _planning.datedebut === res.datedebut);

          // console.log (arrayIndex);

          this.planningEspaces[arrayIndex].reserve = true;
          this.planningEspaces[arrayIndex].idutilisateur = Number(this.currentUser.idutilisateur);
          this.planningEspaces[arrayIndex].idplanning = res.idplanning;

          const date = new Date();
          this.planningService.getAllUser(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idutilisateur).subscribe(plans => {
            sessionStorage.setItem('plan', JSON.stringify(plans));
            this.configService.nbReservationEspace.next(plans.length);
          }, error => {
            config.duration = this.autoHide;
            config.extraClasses = this.addExtraClass ? ['party'] : null;
            this.snackBar.open('Place non disponible.', this.action && this.actionButtonLabel, config);
          });
        } else {
          let date = new Date();
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          config.verticalPosition = 'top';
          this.snackBar.open('La plage horaire n\'est plus disponible.', this.action && this.actionButtonLabel, config);
          this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
        }


      });
    } else {
      // console.log('Annuler planning');

      this.planningService.delete(plan.idplanning).subscribe(res => {
        const arrayIndex = this.planningEspaces.findIndex(_planning => _planning.idplanning === plan.idplanning);
        // console.log('res >', res);

        this.planningEspaces[arrayIndex].reserve = false;
        this.planningEspaces[arrayIndex].idutilisateur = 0;
        this.planningEspaces[arrayIndex].idplanning = '0';

        const date = new Date();
        this.planningService.getAllUser(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idutilisateur).subscribe(plans => {
          sessionStorage.setItem('plan', JSON.stringify(plans));
          this.configService.nbReservationEspace.next(plans.length);
        });

      });
    }
  }

  nextDate() {
    const config = new MatSnackBarConfig();

    this.maDate = new Date(this.maDate.setDate(this.maDate.getDate() + 1));
    // this.nbjourParcours = this.nbjourParcours + 1;
    this.disableprev = false;

    let currentDate = new Date(this.maDate), dateLimit = new Date(this.dateDuJour);

    currentDate.setHours(0, 0, 0, 0);
    dateLimit.setHours(0, 0, 0, 0);


    // currentDate.setDate (currentDate.getDate());
    dateLimit.setDate(dateLimit.getDate() + this.nbjourShow);

    if (+currentDate >= +dateLimit) {
      this.disableNext = true;
    }

    if (this.espaceselected) {
      this.dateInput = this.dateInput.startDate ? this.dateInput.startDate.add(1, 'days') : this.dateInput.add(1, 'days');
      this.daterangepicker.writeValue({startDate: this.dateInput, endDate: this.dateInput});
      this.daterangepicker.picker.updateView();
      this.cdr.detectChanges();
      this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
    } else {
      config.duration = this.autoHide;
      config.extraClasses = this.addExtraClass ? ['party'] : null;
      config.verticalPosition = 'top';
      this.snackBar.open('Veuillez selectionner un espace svp.', this.action && this.actionButtonLabel, config);
    }


    // console.log(this.maDate);
    // console.log(this.dateDuJour);
    // console.log(this.nbjourParcours);

  }

  prevDate() {
    const config = new MatSnackBarConfig();

    this.maDate = new Date(this.maDate.setDate(this.maDate.getDate() - 1));
    /* this.nbjourParcours = this.nbjourParcours - 1; */
    this.disableNext = false;
    let currentDate = new Date(this.maDate);
    currentDate.setDate(currentDate.getDate() - 1);

    currentDate.setHours(0, 0, 0, 0);
    this.dateDuJour.setHours(0, 0, 0, 0);

    if (+currentDate < +this.dateDuJour) {
      this.disableprev = true;
    }
    // console.log(this.maDate);
    // console.log(this.dateDuJour);
    // console.log(this.nbjourParcours);

    if (this.espaceselected) {
      this.dateInput = this.dateInput.startDate ? this.dateInput.startDate.subtract(1, 'days') : this.dateInput.subtract(1, 'days');
      this.daterangepicker.writeValue({startDate: this.dateInput, endDate: this.dateInput});
      this.daterangepicker.picker.updateView();
      this.cdr.detectChanges();
      this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
    } else {
      config.duration = this.autoHide;
      config.extraClasses = this.addExtraClass ? ['party'] : null;
      config.verticalPosition = 'top';
      this.snackBar.open('Veuillez selectionner un espace svp.', this.action && this.actionButtonLabel, config);
    }
  }

  choiceEspace(event) {
    // console.log(event);
    // reset bloc heure
    this.listeBlocHeure = [
      [6, 10],
      [10, 14],
      [14, 18],
      [18, 21]
    ];
    this.espaceselected = event.value;
    // filtre plage horaire
    const heureDebut = (new Date('July 21, 1983 ' + this.espaceselected.heuredebut)).getHours();
    const heureFin = (new Date('July 21, 1983 ' + this.espaceselected.heurefin)).getHours();
    // console.log('heures', heureDebut, heureFin);
    this.listeBlocHeure.forEach(item => {
      if (item[0] < heureDebut && item[1] > heureDebut) {
        //console.log('hereDebut');
        item[0] = heureDebut;
      }
      if (item[1] > heureFin && item[0] < heureFin) {
        //console.log('hereFin');
        item[1] = heureFin;
      }
      // console.log('item blocheure', item);
    });
    // console.log('this.listeblocheure', this.listeBlocHeure);
    this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
  }

  choiceHeure(_event) {
    // console.log(_event.value);
    this.classBlock = 'block-' + _event.value;
  }

  selectDate(date: Date) {
    // console.log(event.value);
    const config = new MatSnackBarConfig();
    this.disableNext = this.disableprev = false;
    this.maDate = date;
    // this.dateDuJour = new Date(event.value);

    const currentDate = new Date(this.maDate), dateLimit = new Date(this.dateDuJour);
    dateLimit.setDate(dateLimit.getDate() + this.nbjourShow);
    dateLimit.setHours(0, 0, 0, 0);

    if (moment(currentDate).isAfter(dateLimit) || moment(currentDate).isSame(dateLimit)) {
      this.disableNext = true;
    }

    if (currentDate.getDate() === this.dateDuJour.getDate()) {
      this.disableprev = true;
    }

    if (this.espaceselected) {
      this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
    } else {
      config.duration = this.autoHide;
      config.extraClasses = this.addExtraClass ? ['party'] : null;
      config.verticalPosition = 'top';
      this.snackBar.open('Veuillez selectionner un espace svp.', this.action && this.actionButtonLabel, config);
    }
  }

  afficherPlanning(date: string, idespace: string) {
    let isChecked = false;
    let valuecChecked = 0;
    // console.log('this.blocHeure', this.blocHeure);
    this.planningService.getAll(date, idespace, this.currentUser.idutilisateur).subscribe(res => {
      // this.planningEspaces = res;
      // affiche les temps non réservés et les temps réservés par le client
      this.planningEspaces = res.filter(plan => {
        let _dateDebut = new Date(plan.datedebut);
        // console.log (_dateDebut, _dateDebut.getHours());
        return ((plan.reserve === false && plan.depasse === false) || (plan.reserve === true));
        // return (plan.reserve === false);
      })

      for (let i = 0; i < 4; i++) {
        this.blocHeure [i] = this.planningEspaces.filter(plan => {
          const _d1 = new Date(plan.datedebut);
          // console.log(plan, (_d1.getHours() >= this.listeBlocHeure[i][0]) &&  (_d1.getHours() < this.listeBlocHeure[i][1]));

          return ((_d1.getHours() >= this.listeBlocHeure[i][0]) && (_d1.getHours() < this.listeBlocHeure[i][1]));
        });
        // console.log(i, '>', this.blocHeure [i].length);

        if (!isChecked && this.blocHeure[i].length > 0) {
          valuecChecked = i;
          isChecked = true;
        }
      }

      // console.log(this.blocHeure);
      this.heureSelect = valuecChecked;
      this.classBlock = 'block-' + valuecChecked;
    });
  }

// gestion date picker
  clickDatePicker() {
    this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
  }

  hideCalendar() {
    this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
    this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    this.selectDate(this.dateInput.startDate.toDate());
  }

  @HostListener('document:click', ['$event.target'])

  public onClickOutSide(targetElement) {
    const clickedInside = this.daterangepicker.picker.pickerContainer.nativeElement.contains(targetElement);
    if (!clickedInside && !this.pickerButton.nativeElement.contains(targetElement)) {
      this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
      this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    }
  }

  public addmember(plan: PlanningEspace , index: number) {
	let idclientsList = []
	// console.log("this.isfamille : "+this.isfamille)

    if(this.isfamille == true){
		this.dialogRef = this.dialog.open(FamilleMemberPlanningComponent, this.configDialog);
		this.dialogRef.componentInstance.idPere = this.currentUser.idclient;
		this.dialogRef.componentInstance.idEspace = Number(this.espaceselected.idespace);
		this.dialogRef.componentInstance.idutilisateur = Number(this.currentUser.idutilisateur);
		this.dialogRef.componentInstance.datedebut = plan.datedebut;
		this.dialogRef.componentInstance.datefin = plan.datefin;

		this.dialogRef.afterClosed().subscribe(()=>{
			this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
		});
	}else{
			if(plan.reserve !== true){
				const message = `Voulez-vous vraiment confirmer votre réservation ?`;
				const dialogData = new ConfirmDialogModel("Réservation activité", message);
				const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				  maxWidth: "400px",
				  panelClass: 'confirm-dialog',
				  data: dialogData
				});
				dialogRef.afterClosed().subscribe(dialogResult => {
					if(dialogResult){
							const planningMultiple = new PlanningMultiple();
							planningMultiple.datedebut = plan.datedebut;
							planningMultiple.datefin = plan.datefin;
							planningMultiple.idespace = Number(this.espaceselected.idespace);
							planningMultiple.idutilisateur = Number(this.currentUser.idutilisateur);
							planningMultiple.idclients.push(this.currentUser.idclient);
							planningMultiple.planningstodelete = [];

							this.planningService.createMultiple(planningMultiple).subscribe(res => {
								const config = new MatSnackBarConfig();
								if (res === true) {
								  config.duration = this.autoHide;
								  config.extraClasses = this.addExtraClass ? ['party'] : null;
								  this.snackBar.open('Votre planning a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
								  this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
								} else {
								  config.duration = this.autoHide;
								  config.extraClasses = this.addExtraClass ? ['party'] : null;
								  this.snackBar.open(' Il y a une erreur lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);
								}

							  }, error => {
								const config = new MatSnackBarConfig();
								config.duration = this.autoHide;
								config.extraClasses = this.addExtraClass ? ['party'] : null;
								this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);

							  });
						}
					});

			}else{
				const message = `Voulez-vous vraiment annuler votre réservation ?`;
				const dialogData = new ConfirmDialogModel("Réservation activité", message);
				const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				  maxWidth: "400px",
				  panelClass: 'confirm-dialog',
				  data: dialogData
				});
				dialogRef.afterClosed().subscribe(dialogResult => {
					if(dialogResult){
							const planningMultiple = new PlanningMultiple();
							planningMultiple.datedebut = plan.datedebut;
							planningMultiple.datefin = plan.datefin;
							planningMultiple.idespace = Number(this.espaceselected.idespace);
							planningMultiple.idutilisateur = Number(this.currentUser.idutilisateur);
							planningMultiple.idclients = [];
							planningMultiple.planningstodelete.push(plan.idplanning);

							this.planningService.removePlanning(planningMultiple).subscribe(res => {
								const config = new MatSnackBarConfig();
								if (res === true) {
								  config.duration = this.autoHide;
								  config.extraClasses = this.addExtraClass ? ['party'] : null;
								  this.snackBar.open('Votre planning a été annulée.', this.action && this.actionButtonLabel, config);
								  this.afficherPlanning(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.espaceselected.idespace);
								} else {
								  config.duration = this.autoHide;
								  config.extraClasses = this.addExtraClass ? ['party'] : null;
								  this.snackBar.open(' Il y a une erreur lors de l\'annulation de votre planning.', this.action && this.actionButtonLabel, config);
								}

							  }, error => {
								const config = new MatSnackBarConfig();
								config.duration = this.autoHide;
								config.extraClasses = this.addExtraClass ? ['party'] : null;
								this.snackBar.open('Une erreur a été rencontrée lors de l\'annulation de votre planning.', this.action && this.actionButtonLabel, config);

							  });
						}
					});
			}
		}
	}
}


@Component({
  selector: 'app-familleMember-dialog',
  templateUrl: 'famille-membres-dialog.html'

})
export class FamilleMemberPlanningComponent {

  idPere: any;
  idEspace: any;
  idutilisateur: any;
  datedebut: Date;
  datefin: Date;
  selectedclient: MembrePlanningEspace[];
  membreFamille: MembrePlanningEspace[];
  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  titre: string;

  constructor(public dialogRef: MatDialogRef<FamilleMemberPlanningComponent>,
              private planningService: PlanningService,
              private clientService: ClientService,
              public snackBar: MatSnackBar ) {

  }

  ngOnInit() {
      this.titre = 'Ajouter des participants';
	  this.planningService.getEspaceClientbyPere(this.idPere, this.datedebut.toString(), this.idEspace).subscribe(res => {
		   this.membreFamille = res;

	  });


  }

  valider(row) {
    const planningMultiple = new PlanningMultiple();
    this.selectedclient = [];
	let planningListId = [];

    this.membreFamille.forEach(element => {
	  if(element.reserved){
		planningListId.push(Number(element.idPlanning))
	  }
   });

    row.selectedOptions.selected.forEach(element => {
		if(element.value.idPlanning === null){
			this.selectedclient.push(element.value.idclient);
		}

        if(element.value.idPlanning != null){
			var myIndex = planningListId.indexOf(element.value.idPlanning);
			if (myIndex !== -1) {
				planningListId.splice(myIndex, 1);
			}
		}

    });

    planningMultiple.datedebut = this.datedebut
	planningMultiple.datefin = this.datefin
	planningMultiple.idespace = this.idEspace
	planningMultiple.idutilisateur = this.idutilisateur
    planningMultiple.idclients = this.selectedclient;
	planningMultiple.planningstodelete = planningListId;

	this.planningService.createMultiple(planningMultiple).subscribe(res => {
        // console.log(res);
        const config = new MatSnackBarConfig();
        if (res === true) {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre planning a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
        } else {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open(' Il y a une erreur lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);
        }

      }, error => {
        const config = new MatSnackBarConfig();
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);

      });

    this.dialogRef.close();


  }
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/reservation/espace/espace.component.ts